// ─── Public Status Page — screen-reader-only text ────────────────────
// The page is mostly colour and shape: a 90-cell uptime bar, status dots,
// filter chips. Every one of those needs a text equivalent that is never
// painted. Clipping (not `display: none`, not `visibility: hidden`) is the only
// technique that keeps the node in the accessibility tree.

import type { ElementType, ReactNode } from 'react';

export interface VisuallyHiddenProps {
  children: ReactNode;
  /** Use 'div'/'p' when the content is block-level; defaults to an inline span. */
  as?: ElementType;
  className?: string;
}

export function VisuallyHidden({ children, as: Tag = 'span', className }: VisuallyHiddenProps) {
  return <Tag className={className ? `sp-sr-only ${className}` : 'sp-sr-only'}>{children}</Tag>;
}
